type PreviewUrls = { html_draft_url?: string; html_published_url?: string };

export type PreviewCommandDeps = {
  /** Read on every click, never captured: a rename or a first publish changes the URLs mid-session. */
  getTemplate: () => PreviewUrls | undefined;
  open: (url: string) => void;
  notify: (message: string) => void;
};

export function createPreviewCommands(deps: PreviewCommandDeps) {
  return {
    openPreview() {
      const url = deps.getTemplate()?.html_draft_url;
      if (url) deps.open(url);
    },
    openLive() {
      const url = deps.getTemplate()?.html_published_url;
      if (url) deps.open(url);
      else deps.notify("No live link available, it hasn't been published yet");
    },
  };
}
